// QRPay.tsx
import React, { useState, useEffect } from 'react';
// import QRCode from 'qrcode.react'; // Make sure this is installed
import {QRCodeSVG} from 'qrcode.react';
// Props interface
interface QRPayProps {
  price?: number;
  upiId?: string;
  currency?: string;
  name?: string;
  description?: string;
}

const QRPay: React.FC<QRPayProps> = ({ 
  price = 0, 
  upiId = '9973358663@PTSBI',
  currency = 'INR',
  name = '',
  description = ''
}) => {
  const [amount, setAmount] = useState<number | string>(price);
  
  // Update amount when price prop changes
  useEffect(() => {
    setAmount(price);
  }, [price]);

  // Create UPI payment URL
  const getUpiUrl = (): string => {
    let url = `upi://pay?pa=${upiId}`;
    
    // Add amount if available
    if (Number(amount) > 0) {
      url += `&am=${amount}`;
    }
    
    // Add currency
    url += `&cu=${currency}`;
    
    // Add name if available
    if (name) {
      url += `&pn=${encodeURIComponent(name)}`;
    }
    
    // Add description if available
    if (description) {
      url += `&tn=${encodeURIComponent(description)}`;
    }
    
    return url;
  };

  // Handle amount change from input
  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value;
    if (value === '' || (Number(value) >= 0 && Number(value) <= 100000)) {
      setAmount(value);
    }
  };

  return (
    <div className="flex flex-col items-center p-6 bg-gray-100 rounded-2xl shadow-lg max-w-md mx-auto border-4 border-white">
      <h1 className="text-2xl font-bold text-blue-600 mb-6">UPI Payment</h1>
      
      <div className="bg-white p-4 rounded-lg shadow mb-4 flex items-center justify-center">
        <QRCodeSVG 
          value={getUpiUrl()}
          size={256}
          level="H"
        />
      </div>
      
      <div className="text-center mb-4">
        <p className="text-lg font-semibold">Scan to pay <span className='text-purple-600 font-bold text-2xl'>₹{amount}</span></p>
        <p className="text-gray-600">to <span className='text-xl text-black font-extrabold'>N A E COACHING</span></p>
        {name && <p className="text-gray-600">for <span className='text-purple-600 font-bold text-xl'>{name}</span></p>}
      </div>
    </div>
  );
};

export default QRPay;